import styled from 'styled-components'
import { Placeholder } from 'semantic-ui-react'

import { FlexRow, Icon, Text, Form } from '@/ui'

// EmployeeSidebar
export const SidebarMenu = styled.div`
  position: fixed;
  left: 65px;
  top: 55px;
  padding-bottom: 55px;
  height: 100%;
  background: #fff;
  width: 250px;
  padding: 0;
  border-right: 1px solid #dbe2e4;
  overflow-y: auto;

  ${({ theme }) => theme.mediaQueries.mobile} {
    position: static;
    width: 100%;
    border: 0;
  }
`

export const SidebarHeader = styled.div`
  padding: 30px 15px 0 15px;
`

export const BackButtonWrapper = styled(FlexRow).attrs({
  justifyContent: 'flex-start',
  alignItems: 'center',
})`
  margin-bottom: 20px;
`

export const LeftArrow = styled(Icon).attrs({
  button: true,
  name: 'icon-arrow-left1',
})`
  top: 3px;
  margin-right: 8px;
`

export const SidebarHeadingWrapper = styled(FlexRow).attrs({
  flexDirection: 'column',
})`
  margin-bottom: 20px;
`

export const EmployeeNameHeading = styled(Text.H2)`
  width: 100%;
  margin: 0 !important;
  margin-bottom: 5px !important;
`

export const EmployeeNameRow = styled(FlexRow.Section).attrs({
  justifyContent: 'space-between',
})`
  width: 100%;
`

export const EmployeeName = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

export const JobTitle = styled(Text.Span).attrs({
  grey: true,
})`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  width: 100%;
`

export const MobilePageSelect = styled(Form.Select)`
  .ui.selection.dropdown[aria-expanded='true'] {
    z-index: 1001; /* 1 higher than the tabs */
  }

  .visible.menu {
    max-height: none !important;
  }
`

export const MobilePlaceholder = styled(Placeholder).attrs({
  fluid: true,
})`
  &,
  .image.header:after,
  .line,
  .line:after,
  > :before {
    background-color: ${({ theme }) => theme.colors.backgroundColor} !important;
  }
`
